import { render, staticRenderFns } from "./ReportSBSAward.vue?vue&type=template&id=1d2efec7&v-if=isLoggedIn&"
import script from "./ReportSBSAward.vue?vue&type=script&lang=js&"
export * from "./ReportSBSAward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports